import { CompanyFeature } from '../graphql/graphql-operations';

export const COMPANY_FEATURES = [
  CompanyFeature.LAUNCH_GROUP_SESSION,
  CompanyFeature.PATIENT_LOGIN,
];
